export default __webpack_public_path__ + "static/media/Logan Kilpatrick.d18dd357.jpg";